/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuthenticateRequestModel,
  ChangeDataRequestModel,
  ChangePasswordRequestModel,
  RegisterRequestModel,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Users<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Users
   * @name LoginCreate
   * @request POST:/Users/Login
   * @secure
   */
  loginCreate = (data: AuthenticateRequestModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Users/Login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name RegisterCreate
   * @request POST:/Users/Register
   * @secure
   */
  registerCreate = (data: RegisterRequestModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Users/Register`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name VerifyEmailDetail
   * @request GET:/Users/VerifyEmail/{userId}
   */
  verifyEmailDetail = (userId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Users/VerifyEmail/${userId}`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name ChangeDataCreate
   * @request POST:/Users/ChangeData
   * @secure
   */
  changeDataCreate = (data: ChangeDataRequestModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Users/ChangeData`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name ChangePasswordCreate
   * @request POST:/Users/ChangePassword
   * @secure
   */
  changePasswordCreate = (data: ChangePasswordRequestModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Users/ChangePassword`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetDataList
   * @request GET:/Users/GetData
   * @secure
   */
  getDataList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Users/GetData`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetSectionsList
   * @request GET:/Users/GetSections
   * @secure
   */
  getSectionsList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Users/GetSections`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetGoalList
   * @request GET:/Users/GetGoal
   * @secure
   */
  getGoalList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Users/GetGoal`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name SetGoalCreate
   * @request POST:/Users/SetGoal
   * @secure
   */
  setGoalCreate = (data: { facultyId: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Users/SetGoal`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetProductsList
   * @request GET:/Users/GetProducts
   * @secure
   */
  getProductsList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Users/GetProducts`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name ChangeEmailCreate
   * @request POST:/Users/ChangeEmail
   * @secure
   */
  changeEmailCreate = (data: { email: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Users/ChangeEmail`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetOnboardingList
   * @request GET:/Users/GetOnboarding
   * @secure
   */
  getOnboardingList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Users/GetOnboarding`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name CompleteOnboardingCreate
   * @request POST:/Users/CompleteOnboarding
   * @secure
   */
  completeOnboardingCreate = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Users/CompleteOnboarding`,
      method: "POST",
      secure: true,
      ...params,
    });
}
